var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CenterFrame',{attrs:{"src":"/welcome"}})
}
var staticRenderFns = []

export { render, staticRenderFns }